import { Core } from "@/core/Core";

export default {

  /* Catalogs */

  async getItemToCategories(context, {inventoryId, active, item, augment = 'embed'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/item_to_categories`, {augment, active, item});
    } catch (e) {
      return null;
    }
  },

  async getCatalogs(context, {inventoryId, augment}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/catalogs`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getCatalogCompanyExclusions(context, inventoryId, catalogId) {
    try {
      return await Core.request("GET", "/api/catalog_company_exclusions", {
        catalog: catalogId,
        inventory: inventoryId
      });
    } catch (e) {
      return null;
    }
  },

  async postCatalogCompanyExclusions(context, exclusions) {
    try {
      return await Core.request("POST", "/api/catalog_company_exclusions", {
        exclusions: exclusions
      });
    } catch (e) {
      return null;
    }
  },

}